import React from 'react';
import { Colors } from '../styles/Colors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudio = ({
  isHovering = false,
  fillBackground = true,
  shadow = false,
  ...props
}) => {
  const backgroundColor = fillBackground ? 'currentColor' : 'transparent';
  const filter = shadow ? 'drop-shadow( 1px 1px 2px rgba(0, 0, 0, .5))' : '';
  return /*#__PURE__*/_jsxs("svg", {
    id: "audio_svg__Ebene_1",
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em",
    ...props,
    style: {
      ...props.style,
      filter
    },
    children: [/*#__PURE__*/_jsx("style", {
      children: `
        .audio_svg__inner {
          fill-rule: evenodd;
          clip-rule: evenodd;
          fill: currentColor;
          stroke: currentColor;
          stroke-width:.2
        }
      `
    }), /*#__PURE__*/_jsxs("g", {
      id: "audio_svg__icon-audio",
      children: [/*#__PURE__*/_jsx("circle", {
        id: "audio_svg__Oval-1",
        cx: 24,
        cy: 24,
        r: shadow ? 20 : 22.7,
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: isHovering ? Colors.RED_af001e : backgroundColor,
        fillOpacity: isHovering ? 1 : 0.32,
        stroke: isHovering ? Colors.RED_af001e : 'currentColor',
        strokeWidth: 1.6,
        strokeOpacity: 1
      }), /*#__PURE__*/_jsxs("g", {
        transform: "translate(13 14)",
        children: [/*#__PURE__*/_jsx("path", {
          id: "audio_svg__Fill-1581",
          d: "M11.7 1.3c-.2-.1-.3 0-.5.1L5.4 7.1H2.6c-.9 0-1.7.7-1.7 1.7v2.5c0 .9.8 1.7 1.7 1.7h2.8l5.8 5.7c.1.1.2.1.3.1h.2c.2-.1.3-.2.3-.4V1.7c-.1-.2-.2-.3-.3-.4",
          fillRule: "evenodd",
          clipRule: "evenodd",
          fill: "currentColor"
        }), /*#__PURE__*/_jsx("path", {
          id: "audio_svg__Fill-1582",
          className: "audio_svg__inner",
          d: "M16.1 4.2c-.2-.2-.4-.2-.6 0-.1.2-.1.4.1.6C17 6 18 7.9 18 9.5c0 1.7-.9 3.5-2.4 4.7-.2.1-.2.4-.1.6.1.1.2.2.3.2.1 0 .2 0 .3-.1 1.6-1.3 2.7-3.5 2.7-5.4 0-1.9-1.1-4-2.7-5.3"
        }), /*#__PURE__*/_jsx("path", {
          id: "audio_svg__Fill-1583",
          className: "audio_svg__inner",
          d: "M14.4 6.3c-.2-.1-.5-.1-.6.1-.1.2-.1.5.1.6.7.5 1.5 1.4 1.5 2.6 0 1.2-.8 2.1-1.5 2.6-.2.1-.2.4-.1.6.1.1.2.2.3.2.1 0 .2 0 .2-.1 1.2-.9 1.9-2 1.9-3.3.1-1.3-.6-2.5-1.8-3.3"
        })]
      })]
    })]
  });
};
export default SvgAudio;